import { ActionReducer } from '@ngrx/store';
import * as enabledApplications from '../actions/application-list.actions';
import * as application from '../actions/application-detail.actions';
import * as applicationDelete from '../actions/application-delete.actions';
import { ErrorAction, errorAdd, errorRemove } from '../../../core/reducers/loading-error.reducer';
import * as clearErrorActions from '../../../core/actions/clear-error.action';
import * as updatePermissions from '../actions/application-update-permissions.actions';

type Actions
    = enabledApplications.Actions
    | application.Actions
    | applicationDelete.Actions
    | clearErrorActions.Actions
    | updatePermissions.Actions;

/**
 * Loading error reducer manages errors during server communication.
 */
export const loadingError: ActionReducer<any> = (state: any = {}, action: Actions) => {

    switch (action.type) {
        case clearErrorActions.CLEAR_ERROR:
            return {};

        // application list load
        case enabledApplications.LOAD_ERROR:
            return errorAdd(state, new ErrorAction(enabledApplications.LOAD_ERROR, action.payload));
        case enabledApplications.LOAD_SUCCESS:
            return errorRemove(state, new ErrorAction(enabledApplications.LOAD_ERROR));

        // application detail load
        case application.LOAD_ERROR:
            return errorAdd(state, new ErrorAction(application.LOAD_ERROR, action.payload));
        case application.LOAD_SUCCESS:
            return errorRemove(state, new ErrorAction(application.LOAD_ERROR));

        // application delete
        case applicationDelete.DELETE_ERROR:
            return errorAdd(state, new ErrorAction(applicationDelete.DELETE_ERROR, action.payload));
        case applicationDelete.DELETE_SUCCESS:
            return errorRemove(state, new ErrorAction(applicationDelete.DELETE_ERROR));

        // first initial update request; authorization iframe follows
        case updatePermissions.UPDATE_PERMISSIONS_ERROR:
            return errorAdd(state, new ErrorAction(updatePermissions.UPDATE_PERMISSIONS_ERROR, action.payload));
        case updatePermissions.UPDATE_PERMISSIONS_SUCCESS:
            return errorRemove(state, new ErrorAction(updatePermissions.UPDATE_PERMISSIONS_ERROR));

        default:
            return state;
    }
};






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/reducers/loading-error.reducer.ts